import { render } from "./AddButton.vue?vue&type=template&id=7c72f86f"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"
script.render = render

export default script